import {SearchRequestParams} from "../../../domain/search/models/search.request-params";
import {SearchDomainService} from "../../../domain/search/services/search-domain-service";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import type {NewSearchWidgetController} from "../new-search-widget.controller";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";
import {SEARCH_FILTERS} from "../../../domain/search/search.consts";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {SearchDataSource} from "../../../domain/search/models/search.data-source";
import {ACTION_TYPES, COMPONENT_STATES, KEY_CODES} from "../../../core/consts";
import {BaseDomainParams} from "../../../infrastructure/models/params/base-domain-params";
import {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";

export class NewSearchWidgetSearchFetchHandler extends FetchHandler {
  controller: NewSearchWidgetController;
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.FETCH.onSearchFetch;

  static injectables = [SearchDomainService];

  onLoaded() {
    super.onLoaded()

    !this.controller.device.isSmallView && window.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.keyCode === KEY_CODES.escape) {
        if(this.state.isSportTypeMenuOpen) {
          this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeMenuClick, {isOpen: false})
        } else {
          this.controller.action(ACTION_TYPES.onSearchClick, {isVisible: false})
        }
      }
    });

    this.controller.historyManager.registerToRouteChanged(() => {
      this.state.shouldResetSearch = true;
      this.controller.action(ACTION_TYPES.onSearchClick, {isVisible: false})
    });

  }

  createDomainParams(fetchParams = {}): BaseDomainParams {
    const sports: Number[] = this.state.selectedSportId === NEW_SEARCH_WIDGET.allSportsId ? null : [this.state.selectedSportId]
    const requestParams: SearchRequestParams = new SearchRequestParams(fetchParams.query, SEARCH_FILTERS.all, sports);
    requestParams.initialParams = this.createInitialRequestParams();
    const params: BaseDomainParams = new BaseDomainParams(requestParams, fetchParams);

    return params;
  }

  async action(params) {
    this.store.setComponentState(COMPONENT_STATES.loading);

    const dataSource: SearchDataSource = await super.fetch(this.createDomainParams(params));
    if (dataSource?.request.params.equals(this.createDomainParams({query: this.state.query}).requestParams)) {
      this.controller.action(ACTION_TYPES.populateData, {dataSource});
    }

    this.store.setComponentState(COMPONENT_STATES.loaded);

    return dataSource;
  }

  isDataSourceValid(request: BaseApiRequestModel) {
    return true;
  }

  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    if(!nextProps.isVisible && prevProps.isVisible === true) {
      this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onNextActionQueryEvent, {
        query: this.state.query,
        isMatchFound: this.state.hasResults ? NEW_SEARCH_WIDGET.ANALYTICS.RESULTS_FOR_SEARCH.hasMatches : NEW_SEARCH_WIDGET.ANALYTICS.RESULTS_FOR_SEARCH.noMatches,
        endedWith: this.state.exitTrigger,
        filteredSportType: this.state.selectedSportId,
        queryStatus: this.state.queryStatus
      })

      if (this.state.shouldResetSearch) {
        if(this.controller.device.isSmallView) {
          await this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSeeAllClick, {id: -1});
        }
        this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onChangeQuery, {query: ''})
      }

      if(this.state.shouldResetSearch || this.state.queryStatus === NEW_SEARCH_WIDGET.ANALYTICS.SEARCH_STATUS.deleted) {
        this.state.queryStatus = NEW_SEARCH_WIDGET.ANALYTICS.SEARCH_STATUS.unTouched;
      }

      this.state.shouldResetSearch = false;
      this.state.exitTrigger = NEW_SEARCH_WIDGET.ANALYTICS.NEXT_ACTION.exit;
    }
  }

}
